export const endpoints = {
  getMerchant: () => `/dashboard/merchants/current`,
  getDigitalWrappers: () => '/dashboard/digital-wrappers',
  uploadAsset: () => '/dashboard/uploads/assets',
  convertAsset: () => '/dashboard/uploads/assets/tojpeg',
  getAssetInfo: () => '/dashboard/uploads/assets/info',
  getEntities: () => '/dashboard/cms-entities',
  getPublicEntities: () => '/public/cms-entities',
  getEntityDetail: ({ id }) => `/dashboard/cms-entities/${id}`
};
